import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../constants/common'
import { useScreen } from '../../../hooks'
import Button from '../../Button'
import { QA_NAME_CREATE_EMAIL } from '../Email.constants'

import * as styles from './EmailCreateButton.module.css'

import PlusIcon from '../../../icons/plus.svg'

function EmailCreateButton({
  beforeIconProps: { Icon = PlusIcon, ...beforeIconProps } = EMPTY_OBJECT,
  className,
  qaName = QA_NAME_CREATE_EMAIL,
  text = 'Emails.AddNewEmailBtnKey',
  ...buttonProps
}) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <Button.Contained
      {...buttonProps}
      beforeIconProps={{ ...beforeIconProps, Icon }}
      className={classNames(className, {
        [styles.mobileSize]: isMobileScreenSize,
      })}
      qaName={qaName}
      text={isMobileScreenSize ? null : t(text)}
    />
  )
}

export default EmailCreateButton
